import axios from 'axios'
export default {
    getClass(id){
        return axios.get('/member/'+ id +'/class-attendance')
            .then(response => {
                return response.data
            })
    },
    join_class(id, formdata){
        return axios.post('/member/' + id + '/class-attendance', formdata)
            .then(response => {
                return response.data
            })
    }, 
    update_class(id,attendance, formdata){
        return axios.put('/member/' + id + '/class-attendance/'+attendance, formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_class(id,attendance){
        return axios.delete('/member/' + id + '/class-attendance/'+attendance)
            .then(response => {
                return response.data
            })
    }, 
}